import { createContext, PropsWithChildren } from 'react';
import { flags, IFeatureFlags } from '../feature-flags';

export const FeatureFlagContext = createContext<IFeatureFlags>(flags);

interface IFeatureFlagProviderProps {}

export function FeatureFlagProvider({ 
  children 
}: PropsWithChildren<IFeatureFlagProviderProps>) {
  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
